import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
export default {
  name: 'maptype',
  props: ['isApp', 'typeList', 'dataList', 'mapdataform', 'iconSource'],
  data() {
    return {
      formUserId: this.$route.query.formUserId,
      zhType: {
        level: [{
          label: '国家级',
          value: 2
        }, {
          label: '省级',
          value: 1
        }, {
          label: '市级',
          value: 3
        }],
        area: []
      },
      zhtypeform: {
        level: '',
        mapType: '',
        area: '',
        placeName: ''
      },
      searchFlag: false,
      defaultdata: [],
      zhListdata: [],
      zhListdataFlag: false,
      heightdata: false
    };
  },
  mounted() {
    // 珠海
    if (this.formUserId === '613539394') {
      this.zhDataform(this.dataList);
      this.searchFlag = !this.isApp ? true : false;
    }
    // 荆州
    if (this.formUserId === '681087410') {
      this.jzDataform(this.dataList);
      this.searchFlag = !this.isApp ? false : true;
    }
  },
  methods: {
    // 移动端按钮切换事件
    zhswitchList() {
      this.heightdata = !this.heightdata;
      this.searchFlag = !this.searchFlag;
    },
    // 搜索事件
    gosearch() {
      let filters = {};
      console.log(this.zhtypeform);
      Object.keys(this.zhtypeform).forEach(item => {
        filters[item] = this.zhtypeform[item] === '' ? [] : this.zhtypeform[item].toString().split(',');
      });
      let cacheData = JSON.parse(JSON.stringify(this.defaultdata));
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.zhListdata = data.map(item => {
        item.itemformdata.placeName = item.itemformdata.placeName.replace(/\ufe35/g, '\uff08');
        item.itemformdata.placeName = item.itemformdata.placeName.replace(/\ufe36/g, '\uff09');
        return item;
      });
      this.zhListdataFlag = this.zhListdata.length === 0 ? true : false;
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'placeName') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    // 列表行点击事件
    listmarkerclick(item) {
      this.$emit('listmarkerclick', item);
    },
    // 珠海处理数据
    zhDataform(data) {
      let dataList = JSON.parse(JSON.stringify(data));
      let mapdataList = dataList.map((item, index) => {
        let pca = item.itemformdata.pca.split('|')[1];
        item.itemformdata.area = pca.split(',')[2];
        let pattern = /-?[1-9]\d*/;
        let imgname = item.itemformdata['4'][0].name;
        let number = imgname.replace(/[^0-9]/ig, '');
        item.itemformdata.level = number;
        switch (Number(number)) {
          case 1:
            item.itemformdata.levelname = '省级';
            break;
          case 2:
            item.itemformdata.levelname = '国家级';
            break;
          default:
            item.itemformdata.levelname = '市级';
            break;
        }
        return item;
      });
      this.zhListdata = JSON.parse(JSON.stringify(mapdataList.reverse()));
      this.defaultdata = this.zhListdata;
      if (this.isApp) return;
      this.zhdataList = [];
      let zhdata = [];
      let pcaArr = [{
        title: '44,4404,440403|广东省,珠海市,斗门区',
        status: 0
      }, {
        title: '44,4404,440408|广东省,珠海市,鹤洲新区',
        status: 0
      }, {
        title: '44,4404,440406|广东省,珠海市,高新区',
        status: 1
      }, {
        title: '44,4404,440402|广东省,珠海市,香洲区',
        status: 1
      }, {
        title: '44,4404,440404|广东省,珠海市,金湾区',
        status: 2
      }, {
        title: '44,4404,440407|广东省,珠海市,横琴粤澳深度合作区',
        status: 2
      }];
      this.zhType.area = pcaArr.map(item => {
        let nameStr = item.title.split('|')[1];
        item.name = nameStr.split(',')[2];
        return item;
      });
      pcaArr.forEach((elem, index) => {
        let elemdata = dataList.filter(item => {
          return item.itemformdata.pca === elem.title;
        });
        zhdata.push(elemdata);
      });
      this.zhdataList = [].concat.apply([], zhdata);
      this.zhdataList.forEach((elem, index) => {
        pcaArr.forEach(aitem => {
          if (aitem.title === elem.itemformdata.pca) {
            elem.itemformdata.status = aitem.status;
          }
        });
        this.createPointTitle(elem.itemformdata, index);
      });
    },
    // 创建绘制文字 0.000175,0.003755
    createPointTitle(item, index) {
      if (item && item['42'] !== '仅展示') {
        // 0.002245,0.002812
        // 0.001235,0.001576
        let titlecolor = '';
        let _this = this;
        let cX = '';
        let cY = '';
        let name = '';
        let textBaseline = 'top';
        if (item.status === 2) {
          cX = Number(0.000785 + (index - 36) * 0.00005);
          cY = Number(0.001576);
          item.placeName = item.placeName.replace(/\uff08/g, '\ufe35');
          item.placeName = item.placeName.replace(/\uff09/g, '\ufe36');
          name = item.placeName.split('').join('\n');
          titlecolor = (index - 2) % 4 === 0 ? '#172d59' : '#475538';
        } else if (item.status === 1) {
          cX = Number(0.002075);
          cY = Number(0.003180 - (index - 20) * 0.00006);
          name = item.placeName;
          if ((index - 20) % 3 === 0) titlecolor = '#482618';
          if ((index - 21) % 3 === 0) titlecolor = '#172d59';
          if ((index - 22) % 3 === 0) titlecolor = '#475538';
          textBaseline = 'left';
        } else {
          cX = Number(0.000165 + index * 0.00005);
          cY = Number(0.003439);
          item.placeName = item.placeName.replace(/\uff08/g, '\ufe35');
          item.placeName = item.placeName.replace(/\uff09/g, '\ufe36');
          name = item.placeName.split('').join('\n');
          titlecolor = (index - 1) % 3 === 0 ? '#482618' : '#475538';
        }
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat([cX, cY])),
          id: `${this.mapdataform.page}${index}`,
          name: item.placeName
        });
        iconFeature.setStyle(new Style({
          text: new StyleText({
            text: name,
            textBaseline: textBaseline,
            textAlign: 'left',
            font: 'normal 12px 宋体',
            fill: new StyleFill({
              color: titlecolor
            })
          })
        }));
        this.iconSource.addFeature(iconFeature);
      }
    },
    jzDataform(data) {
      let datamap = data.map(item => {
        if (item.itemformdata.mapType !== '') {
          switch (item.itemformdata.mapType) {
            case '健身点':
              item.itemformdata.typeId = 0;
              break;
            default:
              item.itemformdata.typeId = 1;
              break;
          }
        }
        return item;
      });
      this.zhListdata = JSON.parse(JSON.stringify(datamap.reverse()));
      this.defaultdata = JSON.parse(JSON.stringify(datamap.reverse()));
    }
  }
};